import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { OtpField } from "./OtpField";

export const ConfirmCodeDialog = ({ open, onOpenChange, title, description, onConfirm, children }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (code.length !== 6) return;
    setBusy(true);
    try {
      await onConfirm(code);
      setCode("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setCode(""); onOpenChange(o); }}>
      <DialogContent className="border-slate-800 bg-[#0b0f19] text-slate-100" data-testid="confirm-2fa-dialog">
        <DialogHeader>
          <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-lg bg-emerald-500/10 text-emerald-400">
            <ShieldCheck size={20} />
          </div>
          <DialogTitle className="font-heading text-xl">{title}</DialogTitle>
          <DialogDescription className="text-slate-400">{description}</DialogDescription>
        </DialogHeader>
        {children}
        <div className="space-y-2">
          <p className="caption">Código do Google Authenticator</p>
          <OtpField value={code} onChange={setCode} testId="confirm-2fa-code-input" />
        </div>
        <Button onClick={submit} disabled={busy || code.length !== 6} className="btn-primary w-full" data-testid="confirm-2fa-submit-button">
          {busy ? "Verificando..." : "Confirmar com 2FA"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
